var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckRoundIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.625 43.625C35.1184 43.625 43.625 35.1184 43.625 24.625C43.625 14.1316 35.1184 5.625 24.625 5.625C14.1316 5.625 5.625 14.1316 5.625 24.625C5.625 35.1184 14.1316 43.625 24.625 43.625ZM34.2207 19.2519C34.751 18.6155 34.6651 17.6697 34.0286 17.1393C33.3922 16.609 32.4464 16.695 31.916 17.3314L22.7625 28.3156C22.6241 28.4817 22.5113 28.6169 22.4118 28.7323C22.3023 28.6264 22.1778 28.502 22.0249 28.3491L17.2401 23.5643C16.6543 22.9786 15.7046 22.9786 15.1188 23.5643C14.533 24.1501 14.533 25.0999 15.1188 25.6857L19.9035 30.4704L19.9555 30.5224C20.2713 30.8385 20.6083 31.1756 20.9292 31.4183C21.3022 31.7003 21.8449 32.0067 22.5589 31.9744C23.2729 31.942 23.7856 31.5877 24.1316 31.273C24.4292 31.0023 24.7342 30.636 25.0202 30.2926L25.0672 30.2362L34.2207 19.2519Z",
    fill: "#0800A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRoundIcon);
export default __webpack_public_path__ + "static/media/CheckRoundIcon.83747b96c953fbc086090a68920f3a69.svg";
export { ForwardRef as ReactComponent };